import React from "react";
import { Progress } from "reactstrap";
import { Storage, StorageData } from "../../../Constant";
import { Btn, H5, LI, UL } from "../../../AbstractElements";
import { Database } from "react-feather";

export const StorageSection = () => {
  return (
    <>
    <UL className="simple-list">
      <LI>
        <Btn outline color="primary" className="progress-text w-100"><Database />{Storage}        </Btn>
        <div className="m-t-15">
          <Progress color="primary" style={{ height: "8px" }} value="25" className="sm-progress-bar mb-3" />
          <H5>{StorageData}</H5>
        </div>
      </LI>
    </UL>
    <hr style={{ opacity: 0.25 }} />
    </>
  );
};
